import React, { useState, useRef, lazy } from 'react';
import { ChevronLeft, ChevronRight, ArrowDownIcon } from 'lucide-react';
const items = [{
  emoji: '🎯',
  tag: 'Tomos 1 & 2',
  title: 'Iniciación y Desarrollo',
  subtitle: 'M6 a M12',
  bullets: ['Tomo 1: Iniciación y Semilleros (M6 a M9)', 'Tomo 2: Desarrollo y Transición al Contacto (M10 a M12)'],
  accent: 'rgba(59,130,246,0.5)',
  glow: 'rgba(59,130,246,0.25)',
  bar: 'bg-blue-500',
  iconBg: 'bg-blue-500/15',
  iconBorder: 'border-blue-500/30',
  textColor: 'text-blue-400',
  bgGradient: 'from-blue-500/15 to-blue-600/0'
}, {
  emoji: '📋',
  tag: 'Tomos 3 & 4',
  title: 'Rendimiento y Preparación Física',
  subtitle: 'Juveniles',
  bullets: ['Tomo 3: Rendimiento, Táctica y Sistema (Juveniles)', 'Tomo 4: Preparación Física Específica para Rugby'],
  accent: 'rgba(34,197,94,0.5)',
  glow: 'rgba(34,197,94,0.25)',
  bar: 'bg-green-500',
  iconBg: 'bg-green-500/15',
  iconBorder: 'border-green-500/30',
  textColor: 'text-green-400',
  bgGradient: 'from-green-500/15 to-green-600/0'
}, {
  emoji: '📱',
  tag: 'Tomos 5 & 6',
  title: 'Drills y Gestión del Coach',
  subtitle: 'Biblioteca + Liderazgo',
  bullets: ['Tomo 5: Gran Biblioteca de Drills (cientos de ejercicios graduados)', 'Tomo 6: Gestión, Liderazgo y Organización del Coach'],
  accent: 'rgba(168,85,247,0.5)',
  glow: 'rgba(168,85,247,0.25)',
  bar: 'bg-purple-500',
  iconBg: 'bg-purple-500/15',
  iconBorder: 'border-purple-500/30',
  textColor: 'text-purple-400',
  bgGradient: 'from-purple-500/15 to-purple-600/0'
}, {
  emoji: '🧤',
  tag: 'Acelerador PRO',
  title: 'Kit Táctico PRO',
  subtitle: 'Para corregir en tiempo real',
  bullets: ['Pizarrón Dinámico + Sistema de Pods para ataque', 'Defensa Presionante + Guía de Análisis de errores'],
  accent: 'rgba(249,115,22,0.5)',
  glow: 'rgba(249,115,22,0.25)',
  bar: 'bg-orange-500',
  iconBg: 'bg-orange-500/15',
  iconBorder: 'border-orange-500/30',
  textColor: 'text-orange-400',
  bgGradient: 'from-orange-500/15 to-orange-600/0'
}];
const carouselImages = [{
  src: 'https://cdn.magicpatterns.com/uploads/evHWy29jDFPBQRabhmG3r4/Captura-de-pantalla-2026-04-25-a-las-9.47.33_p.-m..webp',
  alt: 'Pase de Péndulo vs Pase de Lanzamiento'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/1dytvLo4hxiBotKdToDFbq/Captura-de-pantalla-2026-04-25-a-las-9.48.20_p.-m..webp',
  alt: 'La Batalla en el Suelo — El Ruck'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/iMsQNi2dMji7PU7VrmtxRA/Captura-de-pantalla-2026-04-25-a-las-9.49.06_p.-m..webp',
  alt: 'Secuencia Completa: Código Martillo'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/qJkt8DHGjcjqCkwrXwC6v8/Captura-de-pantalla-2026-04-25-a-las-9.50.41_p.-m..webp',
  alt: 'Los 4 Cuadrantes: Descripción Detallada'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/6RbZN3YDwNTkicWf8Mreb2/Captura-de-pantalla-2026-04-25-a-las-9.51.35_p.-m..webp',
  alt: 'Game On: Competición en el Pasillo de Fuego'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/pCpehdT5cBLaw33UTAa7Wi/Captura-de-pantalla-2026-04-25-a-las-9.52.19_p.-m..webp',
  alt: 'Mapa de Salidas: Posicionamiento en Kick-Off'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/h8WEVQt4Q4LAqHqW6dbUUz/Captura-de-pantalla-2026-04-25-a-las-9.52.43_p.-m..webp',
  alt: 'Planificación de la Temporada: El Macrociclo'
}];
export function ContentPreview() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const handleScroll = () => {
    if (!scrollRef.current) return;
    const container = scrollRef.current;
    const center = container.scrollLeft + container.clientWidth / 2;
    let minDistance = Infinity;
    let active = 0;
    Array.from(container.children).forEach((child, index) => {
      const childCenter = (child as HTMLElement).offsetLeft + (child as HTMLElement).clientWidth / 2;
      const distance = Math.abs(center - childCenter);
      if (distance < minDistance) {
        minDistance = distance;
        active = index;
      }
    });
    setActiveIndex(active);
  };
  const scrollToIndex = (index: number) => {
    if (!scrollRef.current) return;
    const container = scrollRef.current;
    const child = container.children[index] as HTMLElement;
    if (!child) return;
    const scrollLeft = child.offsetLeft - container.clientWidth / 2 + child.clientWidth / 2;
    container.scrollTo({
      left: scrollLeft,
      behavior: 'smooth'
    });
  };
  const scrollPrev = () => {
    if (activeIndex > 0) scrollToIndex(activeIndex - 1);
  };
  const scrollNext = () => {
    if (activeIndex < carouselImages.length - 1) scrollToIndex(activeIndex + 1);
  };
  return <section className="w-full bg-bg-dark py-20 sm:py-28 px-4 relative overflow-hidden" data-id="element-62">
      {/* Decorative background glows */}
      <div className="absolute top-0 right-0 w-[450px] h-[450px] bg-primary/8 rounded-full blur-[130px] pointer-events-none" data-id="element-63"></div>
      <div className="absolute bottom-0 left-0 w-[450px] h-[450px] bg-purple-500/8 rounded-full blur-[130px] pointer-events-none" data-id="element-64"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-65">
        {/* Eyebrow */}
        <div className="flex items-center justify-center gap-3 mb-5" data-id="element-66">
          <span className="h-px w-8 sm:w-12 bg-gradient-to-r from-transparent to-primary/60" data-id="element-67"></span>
          <p className="text-primary font-bold text-sm sm:text-base tracking-[0.2em] uppercase whitespace-nowrap" data-id="element-68">
            📦 El contenido por dentro
          </p>
          <span className="h-px w-8 sm:w-12 bg-gradient-to-l from-transparent to-primary/60" data-id="element-69"></span>
        </div>

        <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-5 text-center tracking-tight leading-tight max-w-3xl mx-auto" data-id="element-70">
          ¿Qué incluye el{' '}
          <span className="relative inline-block" data-id="element-71">
            <span className="relative z-10 text-primary" data-id="element-72">MegaPack Rugby</span>
            <span className="absolute bottom-1 left-0 right-0 h-2 sm:h-3 bg-primary/20 -z-0 rounded-sm" data-id="element-73"></span>
          </span>{' '}
          de EDULABS™?
        </h2>
        <p className="text-text-sec text-base sm:text-xl max-w-2xl mx-auto text-center mb-14 sm:mb-16" data-id="element-74">
          Herramientas digitales en PDF listas para usar desde hoy mismo en tu
          móvil, en formato editorial profesional.
        </p>

        {/* Cards grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 sm:gap-7" data-id="element-75">
          {items.map((item, i) => {
          const num = String(i + 1).padStart(2, '0');
          return <div key={i} className="group relative bg-bg-alt/80 backdrop-blur-sm rounded-3xl border border-border-light overflow-hidden flex flex-col hover:-translate-y-1.5 transition-all duration-500" style={{
            transition: 'transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease'
          }} onMouseEnter={e => {
            e.currentTarget.style.borderColor = item.accent;
            e.currentTarget.style.boxShadow = `0 20px 50px -10px ${item.glow}`;
          }} onMouseLeave={e => {
            e.currentTarget.style.borderColor = '';
            e.currentTarget.style.boxShadow = '';
          }} data-id="element-76">
                {/* Top color bar */}
                <div className={`${item.bar} h-1 w-full`} data-id="element-77" />

                <div className="flex-1 flex flex-col p-7 sm:p-8 relative" data-id="element-78">
                  {/* Hover gradient overlay */}
                  <div className={`absolute inset-0 bg-gradient-to-br ${item.bgGradient} opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none`} data-id="element-79"></div>

                  {/* Number watermark */}
                  <span className={`absolute top-4 right-6 text-5xl sm:text-6xl font-black ${item.textColor} opacity-10 group-hover:opacity-20 transition-opacity duration-500 select-none pointer-events-none leading-none`} data-id="element-80">
                    {num}
                  </span>

                  {/* Icon + tag */}
                  <div className="flex items-center gap-3 mb-5 relative z-10" data-id="element-81">
                    <div className={`w-14 h-14 sm:w-16 sm:h-16 rounded-2xl ${item.iconBg} border ${item.iconBorder} flex items-center justify-center text-3xl sm:text-4xl shadow-inner group-hover:scale-110 transition-transform duration-500`} data-id="element-82">
                      {item.emoji}
                    </div>
                    <span className={`text-[10px] sm:text-xs font-bold uppercase tracking-[0.15em] ${item.textColor} px-2.5 py-1 rounded-full ${item.iconBg} border ${item.iconBorder}`} data-id="element-83">
                      {item.tag}
                    </span>
                  </div>

                  {/* Title + subtitle */}
                  <h3 className="text-xl sm:text-2xl font-black text-text-main leading-tight relative z-10 mb-1 tracking-tight" data-id="element-84">
                    {item.title}
                  </h3>
                  <p className={`text-xs sm:text-sm font-semibold ${item.textColor} mb-4 relative z-10 tracking-wide`} data-id="element-85">
                    {item.subtitle}
                  </p>

                  {/* Bullets list */}
                  <ul className="space-y-2.5 relative z-10" data-id="element-86">
                    {item.bullets.map((b, j) => <li key={j} className="flex items-start gap-2.5 text-text-sec text-sm sm:text-base leading-relaxed" data-id="element-87">
                        <span className={`mt-1.5 flex-shrink-0 w-1.5 h-1.5 rounded-full ${item.bar}`} data-id="element-88"></span>
                        <span data-id="element-89">{b}</span>
                      </li>)}
                  </ul>
                </div>
              </div>;
        })}
        </div>

        {/* Carousel Section */}
        <div className="mt-20 sm:mt-28 relative" data-id="element-90">
          <div className="flex items-center justify-center gap-3 mb-4" data-id="element-91">
            <span className="h-px w-8 bg-gradient-to-r from-transparent to-secondary/60" data-id="element-92"></span>
            <p className="text-secondary font-bold text-xs sm:text-sm tracking-[0.2em] uppercase" data-id="element-93">
              📸 Vista previa
            </p>
            <span className="h-px w-8 bg-gradient-to-l from-transparent to-secondary/60" data-id="element-94"></span>
          </div>

          <h3 className="text-2xl sm:text-4xl font-black text-text-main text-center tracking-tight mb-3" data-id="element-95">
            Mira el material por dentro
          </h3>
          <p className="text-text-sec text-sm sm:text-base text-center mb-10 flex items-center justify-center gap-3 flex-wrap" data-id="element-96">
            <span className="inline-flex items-center gap-1.5 sm:hidden text-primary" data-id="element-97">
              <ChevronLeft className="w-4 h-4 animate-pulse" data-id="element-98" />
              Desliza para ver más
              <ChevronRight className="w-4 h-4 animate-pulse" data-id="element-99" />
            </span>
            <span className="bg-bg-alt border border-border-light px-3 py-1 rounded-full text-text-main text-xs font-bold tracking-wider" data-id="element-100">
              {String(activeIndex + 1).padStart(2, '0')} /{' '}
              {String(carouselImages.length).padStart(2, '0')}
            </span>
          </p>

          <div className="relative group max-w-[100vw] -mx-4 sm:mx-0" data-id="element-101">
            {/* Navigation buttons */}
            <button onClick={scrollPrev} className={`hidden sm:flex absolute left-4 top-1/2 -translate-y-1/2 z-10 bg-bg-alt/90 hover:bg-primary hover:border-primary border border-border-light p-3.5 rounded-full text-text-main backdrop-blur-sm transition-all shadow-xl hover:scale-110 ${activeIndex === 0 ? 'opacity-0 pointer-events-none' : 'opacity-100'}`} aria-label="Anterior" data-id="element-102">
              <ChevronLeft className="w-6 h-6" data-id="element-103" />
            </button>
            <button onClick={scrollNext} className={`hidden sm:flex absolute right-4 top-1/2 -translate-y-1/2 z-10 bg-bg-alt/90 hover:bg-primary hover:border-primary border border-border-light p-3.5 rounded-full text-text-main backdrop-blur-sm transition-all shadow-xl hover:scale-110 ${activeIndex === carouselImages.length - 1 ? 'opacity-0 pointer-events-none' : 'opacity-100'}`} aria-label="Siguiente" data-id="element-104">
              <ChevronRight className="w-6 h-6" data-id="element-105" />
            </button>

            {/* Carousel */}
            <div ref={scrollRef} onScroll={handleScroll} className="flex overflow-x-auto snap-x snap-mandatory scrollbar-hide gap-4 sm:gap-6 px-[10vw] sm:px-[calc(50%-175px)] pb-8 pt-4" data-id="element-106">
              {carouselImages.map((img, i) => <div key={i} className={`snap-center shrink-0 w-[80vw] sm:w-[350px] bg-bg-alt border rounded-2xl overflow-hidden p-2 sm:p-3 flex flex-col items-center justify-center transition-all duration-500 relative ${activeIndex === i ? 'scale-100 opacity-100 border-primary/50 shadow-[0_20px_60px_rgba(59,130,246,0.25)]' : 'scale-95 opacity-50 border-border-light shadow-[0_10px_30px_rgba(0,0,0,0.3)]'}`} data-id="element-107">
                  <img src={img.src} alt={img.alt} loading="lazy" decoding="async" width={800} height={1131} className="w-full h-auto max-h-[400px] sm:max-h-[450px] object-contain rounded-xl bg-white/5" data-id="element-108" />
                  {activeIndex === i && <div className="absolute bottom-4 left-4 right-4 bg-bg-dark/85 backdrop-blur-md border border-primary/30 rounded-xl px-3 py-2 text-text-main text-xs sm:text-sm font-medium text-center shadow-lg" data-id="element-109">
                      {img.alt}
                    </div>}
                </div>)}
            </div>
          </div>

          {/* Dots */}
          <div className="flex justify-center gap-1 mt-2" data-id="element-110">
            {carouselImages.map((_, i) => <button key={i} onClick={() => scrollToIndex(i)} className="p-3 flex items-center justify-center" aria-label={`Ir a imagen ${i + 1}`} data-id="element-111">
                <span className={`block h-2 rounded-full transition-all duration-300 ${i === activeIndex ? 'bg-primary w-8 shadow-[0_0_10px_rgba(59,130,246,0.6)]' : 'bg-border-light hover:bg-text-sec w-2'}`} data-id="element-112" />
              </button>)}
          </div>
        </div>

        {/* Bottom hook → pricing */}
        <div className="mt-16 sm:mt-20 text-center" data-id="element-113">
          <p className="text-text-main text-lg sm:text-xl font-bold mb-3" data-id="element-114">
            Y todo esto es{' '}
            <span className="text-primary" data-id="element-115">solo el contenido principal</span>.
          </p>
          <a href="#pricing" className="inline-flex items-center gap-2 text-cta-green hover:text-cta-green-hover font-black text-base sm:text-lg group transition-colors" data-id="element-116">
            Ver el precio especial de lanzamiento
            <ArrowDownIcon className="w-5 h-5 group-hover:translate-y-1 transition-transform" data-id="element-117" />
          </a>
        </div>
      </div>
    </section>;
}